export const headerJson = {
  fields: {
    iconNavigationLinks: [
      {
        id: "386f4e5d-7e07-4bb4-a649-4aea9ff4f806",
        name: "Login",
        displayName: "Login",
        fields: {
          enableDropdown: { value: true },
          buttonIcon: {
            id: "a12ce2e2-a53a-455b-8c36-2050fedba642",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/team",
            fields: { value: { value: "team" }, key: { value: "Team" } },
          },
          title: { value: "登錄" },
          link: { value: {} },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "Login" },
          gaCategoryName: { value: "" },
        },
        Children: [
          {
            id: "8857e87a-6c66-4c2e-95c5-21592c529311",
            name: "Customer",
            displayName: "Customer",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "個人 / 團體醫療保險 " },
              link: {
                value: {
                  href: "https://eservices.fwd.com.hk/web/fwd/login/index",
                  linktype: "external",
                  url: "https://eservices.fwd.com.hk/web/fwd/login/index",
                  anchor: "",
                  target: "",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Individual / Group Medical Insurance " },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "68c50418-4c45-4ebc-812b-809d77ded615",
            name: "MPF account",
            displayName: "MPF account",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "強積金賬戶 " },
              link: {
                value: {
                  text: "",
                  linktype: "modelpopup",
                  querystring: "",
                  target: "",
                  id: "{D6037E42-3522-4EDD-8CD8-F814F3528E6B}",
                  disclosurepopupcontent: {
                    disclosure: {
                      value: "d6037e42-3522-4edd-8cd8-f814f3528e6b",
                    },
                  },
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "MPF account" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "196ffd7d-c5d6-491e-a472-52f8857fc7d3",
            name: "Agents",
            displayName: "Agents",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "理財顧問 " },
              link: {
                value: {
                  href: "https://irisplus.fwd.com.hk/",
                  text: "Agents",
                  linktype: "external",
                  url: "https://irisplus.fwd.com.hk/",
                  anchor: "",
                  target: "",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Agent Login" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "c2be08a0-e9db-4930-a9c1-44e935e38e52",
            name: "Partners",
            displayName: "Partners",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "合作伙伴 " },
              link: {
                value: {
                  href: "https://irisplus.fwd.com.hk/",
                  linktype: "external",
                  url: "https://irisplus.fwd.com.hk/",
                  anchor: "",
                  target: "",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Partners Login" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "86e3ca61-2631-4739-bce5-d03e1499fcf3",
            name: "FWD Wellness Pass",
            displayName: "FWD Wellness Pass",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "富衛健康通行證" },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/fwd-wellness-pass",
                  text: "富衛健康通行證",
                  linktype: "external",
                  url: "https://www.fwd.com.hk/fwd-wellness-pass",
                  anchor: "",
                  target: "_blank",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Wellness-pass" },
              gaCategoryName: { value: "" },
            },
          },
        ],
      },
      {
        id: "4b5352aa-8be7-41a0-8131-17a60c0f5588",
        name: "Support",
        displayName: "Support",
        fields: {
          enableDropdown: { value: true },
          buttonIcon: {
            id: "79cc843a-2212-40b5-b09f-2018d04c72a9",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/contact",
            fields: { value: { value: "contact" }, key: { value: "Contact" } },
          },
          title: { value: "" },
          link: { value: {} },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "Support" },
          gaCategoryName: { value: "" },
        },
        Children: [
          {
            id: "d4cd8abe-7723-4e70-9d3b-65390303e779",
            name: "Call",
            displayName: "Call",
            fields: {
              buttonIcon: {
                id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/call",
                fields: { value: { value: "call" }, key: { value: "Call" } },
              },
              title: { value: "致電 3123 3123 " },
              link: {
                value: {
                  href: "http://tel:31233123",
                  linktype: "external",
                  url: "tel:31233123",
                  anchor: "",
                  target: "",
                },
              },
              listType: {
                id: "fd670504-d972-4fee-9582-656b0d6ba342",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                fields: { value: { value: "Call" }, key: { value: "call" } },
              },
              gaLabelName: { value: "Call" },
              gaCategoryName: { value: "" },
            },
          },
          // {
          //   id: "c7e12cea-809d-4bc1-a5ca-3fc5fdc9d09b",
          //   name: "Chat",
          //   displayName: "Chat",
          //   fields: {
          //     buttonIcon: {
          //       id: "631bc306-c30e-4d10-afe5-670237118479",
          //       fieldType: "CustomDroplink",
          //       fieldName: "buttonIcon",
          //       url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chat",
          //       fields: { value: { value: "chat" }, key: { value: "chat" } },
          //     },
          //     title: { value: "即時對話 " },
          //     link: { value: {} },
          //     listType: {
          //       id: "5e19aacf-53fc-4f68-a278-b0c8ab1c5b67",
          //       fieldType: "Droplink",
          //       fieldName: "listType",
          //       url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/chat",
          //       fields: { value: { value: "Chat" }, key: { value: "chat" } },
          //     },
          //     gaLabelName: { value: "Chat" },
          //     gaCategoryName: { value: "" },
          //   },
          // },
        ],
      },
      {
        id: "2ecea1f2-4d14-4b34-8ed5-d8ed889a6730",
        name: "Search",
        displayName: "Search",
        fields: {
          enableDropdown: { value: false },
          buttonIcon: {
            id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/search",
            fields: { value: { value: "search" }, key: { value: "Search" } },
          },
          title: { value: "" },
          link: {
            value: {
              href: "https://www.fwd.com.hk/search/",
              text: "",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              querystring: "",
              id: "{AA2127DC-2C63-4FDD-B43D-2583EC5200A4}",
            },
          },
          listType: {
            id: "b91e87f2-99cc-4a93-a0ba-3ee8c14f36a4",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/search",
            fields: { value: { value: "Search" }, key: { value: "search" } },
          },
          gaLabelName: { value: "Search" },
          gaCategoryName: { value: "" },
        },
      },
    ],
    headerNavigationLinks: [
      {
        id: "03f7d1bb-e0de-498f-bec2-918e48c3be3d",
        name: "personal-insurance",
        displayName: "personal-insurance",
        fields: {
          buttonIcon: null,
          title: { value: "個人保障 " },
          link: {
            value: {
              href: "https://www.fwd.com.hk/products/",
              text: "",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              target: "",
              querystring: "",
              id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
            },
          },
          pageType: {
            id: "4fded742-177c-4850-9853-fa31cc47d63e",
            fieldType: "Droptree",
            fieldName: "pageType",
            url: "https://www.fwd.com.hk/components/pagetype/individual",
            fields: {
              value: { value: "Individual" },
              key: { value: "individual" },
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "Personal insurance" },
          gaCategoryName: { value: "" },
        },
        Children: [
          {
            id: "7e9ea3f0-9071-4379-a25c-f1ac576e3463",
            name: "Products",
            displayName: "Products",
            fields: {
              buttonIcon: {
                id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/products",
                fields: {
                  value: { value: "products" },
                  key: { value: "products" },
                },
              },
              title: { value: "產品 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/products/",
                  text: "",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  target: "",
                  querystring: "",
                  id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                },
              },
              pageType: {
                id: "4fded742-177c-4850-9853-fa31cc47d63e",
                fieldType: "Droptree",
                fieldName: "pageType",
                url: "https://www.fwd.com.hk/components/pagetype/individual",
                fields: {
                  value: { value: "Individual" },
                  key: { value: "individual" },
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Products" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "263a64a1-ba2e-48cb-b459-882d4d37430f",
            name: "Buy online",
            displayName: "Buy online",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "網上投保" },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/online-insurance/",
                  linktype: "external",
                  url: "https://www.fwd.com.hk/online-insurance/",
                  anchor: "",
                  target: "_blank",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "ce7d4b83-4bcc-4064-ab5d-6407be87d748",
            name: "Support",
            displayName: "Support",
            fields: {
              buttonIcon: {
                id: "fbdc2dbb-311b-47d3-929d-214d7b812ba5",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/supportoutline---obsolete",
                fields: {
                  value: { value: "support-outline" },
                  key: { value: "supportOutline" },
                },
              },
              title: { value: "支援 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/support/",
                  text: "",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Support" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "0adc557e-2d1f-4a94-a991-5bdffb56e3a7",
            name: "Claims",
            displayName: "Claims",
            fields: {
              buttonIcon: {
                id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/claims",
                fields: {
                  value: { value: "claims" },
                  key: { value: "claims" },
                },
              },
              title: { value: "索償 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/claims/",
                  text: "Claims",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{1ECCEDC9-E80A-4521-A507-CC81BD2A5EC6}",
                },
              },
              pageType: {
                id: "4fded742-177c-4850-9853-fa31cc47d63e",
                fieldType: "Droptree",
                fieldName: "pageType",
                url: "https://www.fwd.com.hk/components/pagetype/individual",
                fields: {
                  value: { value: "Individual" },
                  key: { value: "individual" },
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Claims" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "2dc44112-f941-4b79-8850-41d7b81f0509",
            name: "Live",
            displayName: "Live",
            fields: {
              buttonIcon: {
                id: "2fb55194-6b17-4d01-acf7-d7455cf1b768",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/criticalillness",
                fields: {
                  value: { value: "critical-illness" },
                  key: { value: "criticalIllness" },
                },
              },
              title: { value: "網誌" },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/blog/",
                  text: "Live",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{68E8B2B6-DD6C-411F-91E1-B1B25B2107EB}",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "" },
              gaCategoryName: { value: "" },
            },
          },
        ],
      },
      {
        id: "089319f0-9b3b-4d3e-8efc-627dc9a0fdd2",
        name: "business-insurance",
        displayName: "business-insurance",
        fields: {
          buttonIcon: null,
          title: { value: "企業保障 " },
          link: {
            value: {
              href: "https://www.fwd.com.hk/business/",
              text: "business product landing page",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              querystring: "",
              id: "{BBB4F360-4715-4653-8CDE-BA9E60D1E26D}",
            },
          },
          pageType: {
            id: "de6c17ec-dbdd-4363-9494-5437e7f5eb8b",
            fieldType: "Droptree",
            fieldName: "pageType",
            url: "https://www.fwd.com.hk/components/pagetype/business",
            fields: {
              value: { value: "Business" },
              key: { value: "business" },
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "Business insurance" },
          gaCategoryName: { value: "" },
        },
        Children: [
          {
            id: "d1abefd7-61f3-4b42-b8ef-5d708bcf809a",
            name: "Products",
            displayName: "Products",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "產品 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/business/",
                  text: "",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{BBB4F360-4715-4653-8CDE-BA9E60D1E26D}",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Products" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "67f87d28-686e-43a6-9e12-360f9888baca",
            name: "Support",
            displayName: "Support",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "支援 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/business/support/",
                  text: "",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{E4F2827A-E55D-4DC5-80F3-354AD44C78C8}",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Support" },
              gaCategoryName: { value: "" },
            },
          },
          {
            id: "52c758aa-80b2-46c9-8587-09586d65c8e0",
            name: "Claims",
            displayName: "Claims",
            fields: {
              buttonIcon: {
                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                fields: {
                  value: { value: "chevron-right" },
                  key: { value: "chevronRight" },
                },
              },
              title: { value: "索償 " },
              link: {
                value: {
                  href: "https://www.fwd.com.hk/business/claims/",
                  text: "",
                  anchor: "",
                  linktype: "internal",
                  class: "",
                  title: "",
                  querystring: "",
                  id: "{CC6F6069-65DE-4A82-8A12-86402AC320C4}",
                },
              },
              listType: {
                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                fieldType: "Droplink",
                fieldName: "listType",
                url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                fields: {
                  value: { value: "Generic Link" },
                  key: { value: "generic_link" },
                },
              },
              gaLabelName: { value: "Claims" },
              gaCategoryName: { value: "" },
            },
          },
        ],
      },
      {
        id: "f57b6b73-b940-4bec-a14a-4d82d9de70c8",
        name: "FWD Max",
        displayName: "FWD Max",
        fields: {
          buttonIcon: null,
          title: { value: "FWD Max" },
          link: {
            value: {
              href: "https://fwdmax.fwd.com.hk/#/",
              linktype: "external",
              url: "https://fwdmax.fwd.com.hk/#/",
            },
          },
          pageType: {
            id: "4fded742-177c-4850-9853-fa31cc47d63e",
            fieldType: "Droptree",
            fieldName: "pageType",
            url: "https://www.fwd.com.hk/components/pagetype/individual",
            fields: {
              value: { value: "Individual" },
              key: { value: "individual" },
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "FWD Max" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "fc43b3cb-09f9-458c-a359-435548e15c3c",
        name: "FWD Care",
        displayName: "FWD Care",
        fields: {
          buttonIcon: null,
          title: { value: "FWD Care" },
          link: {
            value: {
              href: "https://www.fwd.com.hk/fwd-care/",
              text: "",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              target: "",
              querystring: "",
              id: "{6264591E-F484-4C44-9F22-76CC0AAAA96C}",
            },
          },
          pageType: {
            id: "4fded742-177c-4850-9853-fa31cc47d63e",
            fieldType: "Droptree",
            fieldName: "pageType",
            url: "https://www.fwd.com.hk/components/pagetype/individual",
            fields: {
              value: { value: "Individual" },
              key: { value: "individual" },
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "FWD Care" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "43605822-a526-4658-a490-e8307981a5b7",
        name: "about-us",
        displayName: "about-us",
        fields: {
          buttonIcon: {
            id: "368ba79d-8cae-435c-a781-fe6fb2f3725d",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/linkvariant/collection---obsolete",
            fields: {
              value: { value: "collection" },
              key: { value: "Collection" },
            },
          },
          title: { value: "關於我們" },
          link: {
            value: {
              href: "https://www.fwd.com.hk/about-us/",
              text: "",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              querystring: "",
              id: "{E5F9A3FD-CB1D-4BE3-BC8B-C33AB0CA8199}",
            },
          },
          pageType: {
            id: "de6c17ec-dbdd-4363-9494-5437e7f5eb8b",
            fieldType: "Droptree",
            fieldName: "pageType",
            url: "https://www.fwd.com.hk/components/pagetype/business",
            fields: {
              value: { value: "Business" },
              key: { value: "business" },
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "About us" },
          gaCategoryName: { value: "" },
        },
      },
    ],
    mobileLogo: {
      value: {
        src: "https://www.fwd.com.hk/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1",
        alt: "Mobile Logo",
        x1: "https://www.fwd.com.hk/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1&cx=0&cy=0&cw=160&ch=55&hash=7022D21F9F18BB0976118AB5D2581224",
        x2: "https://www.fwd.com.hk/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1&cx=0&cy=0&cw=320&ch=110&hash=7AA10FB71EF1FBCEA89E0E4CEC328D3A",
      },
    },
    logo: {
      value: {
        src: "https://www.fwd.com.hk/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38",
        alt: "Desktop Logo",
        x1: "https://www.fwd.com.hk/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38&cx=0.34&cy=0.49&cw=420&ch=145&hash=BA06E53B6851E960624E0E9D65530568",
        x2: "https://www.fwd.com.hk/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38&cx=0.34&cy=0.49&cw=840&ch=290&hash=6B51AE82CBDA193DA8CCB3D5FABFC3DB",
      },
    },
    logoLink: {
      value: {
        text: "Home",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "Home",
        querystring: "",
        id: "{D9C6779B-43E9-4106-8357-AD0510A8547C}",
      },
    },
    headerLogo: {
      value: {
        src: "https://www.fwd.com.hk/-/media/global/images/fwdlogod.svg?rev=a209dbca469647fa89f47c76a00dc55c",
        alt: "FWD Desktop Logo",
      },
    },
    countrySelector: [
      {
        id: "b43fd69b-bd63-4f64-9aab-06f1b0d527c7",
        name: "Group",
        displayName: "Group",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "富衛集團" },
          link: {
            value: {
              href: "https://www.fwd.com/",
              linktype: "external",
              url: "https://www.fwd.com/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "eb9ee5ea-e079-4bde-af3c-b82e5ebee28a",
        name: "Hong Kong",
        displayName: "Hong Kong",
        fields: {
          isDefault: { value: true },
          buttonIcon: null,
          title: { value: "香港" },
          link: {
            value: {
              href: "https://www.fwd.com.hk/",
              text: "",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              querystring: "",
              id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "dc6f0a0c-f056-44c6-a565-2044c8b494a6",
        name: "Macau",
        displayName: "Macau",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "澳門" },
          link: {
            value: {
              href: "https://www.fwd.com.mo/en/",
              linktype: "external",
              url: "https://www.fwd.com.mo/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "62bb0970-5392-494c-8969-53863b8728d3",
        name: "China representative office",
        displayName: "China representative office",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "中國代表處" },
          link: {
            value: {
              href: "https://www.fwd.cn/",
              linktype: "external",
              url: "https://www.fwd.cn/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "79ec13ea-0312-44f7-b305-3660acd71adf",
        name: "Indonesia",
        displayName: "Indonesia",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "印尼" },
          link: {
            value: {
              href: "https://www.fwd.co.id/en/",
              linktype: "external",
              url: "https://www.fwd.co.id/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "e5b1b516-9ca4-4a59-9417-03cdedeaab5a",
        name: "Japan",
        displayName: "Japan",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "日本" },
          link: {
            value: {
              href: "https://www.fwdlife.co.jp/",
              linktype: "external",
              url: "https://www.fwdlife.co.jp/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "d3f70c56-ff92-468e-a8e7-bdede76909d1",
        name: "Malaysia",
        displayName: "Malaysia",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "馬來西亞" },
          link: {
            value: {
              href: "https://www.fwd.com.my/en/",
              linktype: "external",
              url: "https://www.fwd.com.my/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "0bff6386-fa8a-4ba5-800f-24c2afffbbe0",
        name: "Philippines",
        displayName: "Philippines",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "菲律賓" },
          link: {
            value: {
              href: "https://www.fwd.com.ph/en/",
              linktype: "external",
              url: "https://www.fwd.com.ph/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "7bb44e4e-75eb-4b9d-8ff8-4a4a8203cf36",
        name: "Singapore",
        displayName: "Singapore",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "新加坡" },
          link: {
            value: {
              href: "https://www.fwd.com.sg/",
              linktype: "external",
              url: "https://www.fwd.com.sg/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "dc572c84-d525-48c9-a5e0-6215970d93b4",
        name: "Thailand",
        displayName: "Thailand",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "泰國" },
          link: {
            value: {
              href: "https://www.fwd.co.th/en/",
              linktype: "external",
              url: "https://www.fwd.co.th/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
      {
        id: "4499f614-f9e5-4cd8-a924-8a8ce0c82348",
        name: "Vietnam",
        displayName: "Vietnam",
        fields: {
          isDefault: { value: false },
          buttonIcon: null,
          title: { value: "越南" },
          link: {
            value: {
              href: "https://www.fwd.com.vn/en/",
              linktype: "external",
              url: "https://www.fwd.com.vn/en/",
              anchor: "",
              target: "_blank",
            },
          },
          listType: {
            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
        },
      },
    ],
    displayMode: {
      id: "c81d8d8f-e8d9-468f-acfc-bbdce30d66ec",
      fieldType: "Droplink",
      fieldName: "displayMode",
      url: "https://www.fwd.com.hk/sitecore/content/fwd/global/settings/list/carouselmode/mobile",
      fields: { value: { value: "Mobile" }, key: { value: "Mobile" } },
    },
    searchPageLink: {
      value: {
        href: "https://www.fwd.com.hk/search/",
        text: "",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "",
        querystring: "",
        id: "{AA2127DC-2C63-4FDD-B43D-2583EC5200A4}",
      },
    },
    pastSearchRecordsCount: { value: "8" },
    title: { value: "我在找 ..." },
    placeholderText: { value: "請輸入關鍵字或者詞組 " },
    enableLanguageToggle: { value: true },
    languageList: [
      {
        id: "f7d73a71-1c14-4b6a-8db1-263b40425b4f",
        fields: {
          languageName: { value: "EN" },
          defaultLanguage: { value: "tc" },
          languageCode: { value: "en" },
        },
      },
      {
        id: "8e721d84-8219-4d9b-9470-4621a8beff37",
        fields: {
          languageName: { value: "繁" },
          defaultLanguage: { value: "En" },
          languageCode: { value: "tc" },
        },
      },
    ],
    languageModalDescription: {
      value:
        "We currently working to have this content in your language. You can choose to stay on this page, or proceed to explore other relevant content.",
    },
    languageModalLink: {
      value: {
        href: "https://www.fwd.com.hk/",
        text: "Explore",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "Okie",
        target: "",
        querystring: "",
        id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
      },
    },
    languageModalSecondaryLink: { value: "Stay on page" },
    languageModalTitle: {
      value: "This content might not be in your language.",
    },
  },
  params: {
    backgroundColor: "white-orange",
    paddingTop: "None",
    paddingBottom: "None",
  },
  sitecoreContext: {
    language: "繁",
    languageCode: "tc",
    availableLanguages: ["tc", "en"],
  },
};
